import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';
import { IApplicationContext } from '../../containers/App';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';
import { filterReducer, noopReducer, residentialComplexesIdsReducer } from '../../reducers';
import { defaultHashState } from '../../__mocks__/store';
import { getMapApiKey, getSubdomain } from '../../selectors';
import { specialPromosBlocksReducer } from '../../reducers/specialPromosBlocks/reducer';

let storeReminder: TReduxStore;

interface ICreateReduxStore {
  initialState: IApplicationState;
  debugEnabled?: boolean;
  context: IApplicationContext;
}

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param context – IApplicationContext
 * @param debugEnabled – включение дебаг мода
 */
export function createReduxStore({ initialState, context, debugEnabled }: ICreateReduxStore) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    filter: filterReducer,
    banners: noopReducer(defaultHashState),
    locations: noopReducer(defaultHashState),
    residentialComplexes: noopReducer(defaultHashState),
    residentialComplexesIds: residentialComplexesIdsReducer,
    common: noopReducer({ mapApiKey: getMapApiKey(initialState), subdomain: getSubdomain(initialState) }),
    promos: noopReducer(initialState.promos),
    user: noopReducer(initialState.user),
    adfox: noopReducer(initialState.adfox),
    specialPromosBlocks: specialPromosBlocksReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const middlewares = [thunk.withExtraArgument(context)];

  const storeEnchancers = composeEnhancers(
    compose(applyMiddleware(...middlewares)),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IApplicationState, {}>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
